
import { computed, defineComponent, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import useOpenInfo from '@/hooks/openInfo'
import stepPercentage from '@/utils/number'
import { setApptitle } from '@/utils/native-app'
import dayjs from 'dayjs'
import * as storage from '@/utils/storage'
import { useMutation } from '@vue/apollo-composable'
import { dobuleSaveDraft, mutateApi } from '@/graphql/mutation'

export default defineComponent({
  setup () {
    const router = useRouter()
    const formType = computed(() => storage.get('formType'))
    const commomParams = ref()
    const privilegeList = [
      {
        name: '国际配售',
        url: require('@/assets/images/international.svg')
      },
      {
        name: '私募基金',
        url: require('@/assets/images/fund.svg')
      },
      {
        name: '非零售债券',
        url: require('@/assets/images/non-retail.svg')
      }
    ]
    const isPiVerify = ref(1)
    const { openType, meta, title, step, saveCommonOfVuex, saveOpenInfoOfVuex } = useOpenInfo()
    const handleNext = () => {
      isPiVerify.value = 1
      const percentage = stepPercentage(step)
      commomParams.value = {
        openType: openType.value,
        openStatus: 0,
        btnText: '继续开户',
        remark: `已完成${percentage}%，请继续完善资料`,
        step
      }
      saveClientDraft({
        param: {
          formType: formType.value,
          meta: meta.value,
          content: JSON.stringify({
            isPiVerify: isPiVerify.value
          })
        },
        commomParams: {
          formType: formType.value,
          meta: 'open_common',
          content: JSON.stringify(commomParams.value)
        }
      })
    }
    const skipPI = () => {
      isPiVerify.value = 0
      const params = {
        formType: formType.value,
        meta: meta.value,
        content: JSON.stringify({
          isPiVerify: isPiVerify.value
        })
      }
      skipSaveClientDraft({ params })
    }
    // 存储缓存表方法
    const { mutate: saveClientDraft, onDone } = useMutation(dobuleSaveDraft)
    onDone((res) => {
      const { saveClientFormDraft, commonDraft } = res.data
      if (saveClientFormDraft.ok && commonDraft.ok) {
        saveCommonOfVuex({ info: commomParams.value })
        saveOpenInfoOfVuex({ info: { isPiVerify: isPiVerify.value } })
        router.push({ name: 'pi-risk' })
      }
    })

    const { mutate: skipSaveClientDraft, onDone: skipDone } = useMutation(mutateApi.saveClientFormDraft)
    skipDone((res) => {
      const { saveClientFormDraft } = res.data
      if (saveClientFormDraft.ok) {
        saveOpenInfoOfVuex({ info: { isPiVerify: isPiVerify.value } })
        const expireTime = dayjs(storage.get('captcha_expire_time'))
        const diff = dayjs().diff(expireTime, 'minute', true)
        if (diff < 10) {
          router.push({ name: 'confirm' })
        } else {
          router.push({ name: 'captcha' })
          storage.remove('captcha_expire_time')
        }
      }
    })

    onMounted(() => {
      setApptitle(title)
    })

    return { handleNext, privilegeList, isPiVerify, skipPI }
  }
})
